import Cookies from 'js-cookie';

const base = () => process.env.REACT_APP_BACKEND_ADDRESS;
const headers = () => ({ 'Authorization': 'Bearer ' + Cookies.get('token'), 'Content-Type': 'application/json' });

export async function fetchCollections() {
    const res = await fetch(`${base()}/collections`, { headers: headers() });
    if (!res.ok) throw new Error('Failed to fetch collections');
    return res.json();
}

export async function createCollection(name) {
    const res = await fetch(`${base()}/collections`, {
        method: 'POST', headers: headers(), body: JSON.stringify({ name }),
    });
    if (!res.ok) throw new Error('Failed to create collection');
    return res.json();
}

export async function updateCollection(id, { name, description } = {}) {
    const res = await fetch(`${base()}/collections/${id}`, {
        method: 'PATCH', headers: headers(), body: JSON.stringify({ name, description }),
    });
    if (!res.ok) throw new Error('Failed to update collection');
    return res.json();
}

export async function deleteCollection(id) {
    const res = await fetch(`${base()}/collections/${id}`, { method: 'DELETE', headers: headers() });
    if (!res.ok) throw new Error('Failed to delete collection');
}

export async function addToCollection(collectionId, recipeId) {
    const res = await fetch(`${base()}/collections/${collectionId}/recipes`, {
        method: 'POST', headers: headers(), body: JSON.stringify({ recipe_id: recipeId }),
    });
    if (!res.ok) throw new Error('Failed to add recipe to collection');
    return res.json();
}

export async function removeFromCollection(collectionId, recipeId) {
    const res = await fetch(`${base()}/collections/${collectionId}/recipes/${recipeId}`, {
        method: 'DELETE', headers: headers(),
    });
    if (!res.ok) throw new Error('Failed to remove recipe from collection');
}

export async function shareCollection(collectionId, userId, permission = 'view') {
    const res = await fetch(`${base()}/collections/${collectionId}/shares`, {
        method: 'POST', headers: headers(), body: JSON.stringify({ user_id: userId, permission }),
    });
    if (!res.ok) throw new Error('Failed to share collection');
    return res.json();
}

export async function leaveCollection(collectionId) {
    const res = await fetch(`${base()}/collections/${collectionId}/leave`, {
        method: 'DELETE', headers: headers(),
    });
    if (!res.ok) throw new Error('Failed to leave collection');
}

export async function unshareCollection(collectionId, userId) {
    const res = await fetch(`${base()}/collections/${collectionId}/shares/${userId}`, {
        method: 'DELETE', headers: headers(),
    });
    if (!res.ok) throw new Error('Failed to unshare collection');
}
